export function nextFutureDate(
    dates: Date[],
    currentDate = new Date(),
): Date | undefined {
    const sortedDates = dates.sort((a, b) => Number(a) - Number(b));
    const futureDates = sortedDates.filter((date) => date > currentDate);
    return futureDates.shift();
}

export function previousPastDate(
    dates: Date[],
    pastDate: Date,
    currentDate = new Date(),
): Date | undefined {
    const sortedDates = dates.sort((a, b) => Number(a) - Number(b));
    const previousDates = sortedDates.filter(
        (date) => date > pastDate && date < currentDate,
    );
    return previousDates.pop();
}
